import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { GeneralService } from "../services/general.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MenuComponent implements OnInit {
  constructor(private router: Router, public generalService: GeneralService) {}

  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    }
  }
  logout() {
    console.log(1);

    this.router.navigate([""]);
    console.log(2);

    localStorage.setItem("login", "false");
    console.log(3);

    this.generalService.userLogin = false;
    console.log(4);
  }
}
